import './styles/TopNavToastMessageStyle.css';
import { useEffect, useState } from 'react';
export enum ToastType {
  SUCCESS = 'success',
  WARNING = 'fail',
  ERROR = 'error',
}
interface TopNavToastMessageProps {
  toastText: string;
  toastType: ToastType;
  resetMessage(): void;
}
const TopNavToastMessage: React.FC<TopNavToastMessageProps> = ({
  toastText,
  toastType,
  resetMessage,
}) => {
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    if (toastText !== '') {
      setShowToast(true);
    }
    const delayDebounceFn = setTimeout(async () => {
      // Send Axios request here
      setShowToast(false);
      resetMessage();
    }, 15000);

    return () => clearTimeout(delayDebounceFn);
  }, [toastText]);
  return (
    <div
      onClick={() => setShowToast(false)}
      className={`top-nav-toast-message-container ${toastType} ${
        !showToast ? 'collapsed' : ''
      }`}
    >
      <p className="top-nav-toast-message">{toastText}</p>
    </div>
  );
};

export { TopNavToastMessage };
